// src/appInsights.js
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableTelemetry: process.env.NODE_ENV === 'development',
  },
});

appInsights.loadAppInsights();

// Custom sampling per telemetry type
appInsights.addTelemetryInitializer((envelope) => {
  const type = envelope.baseType;

  const sampleRates = {
    PageviewData:      100,   // always send page views
    EventData:         75,    // 75% of custom events
    ExceptionData:     100,   // always send exceptions
    RemoteDependencyData: 25, // only 25% of dependency calls (e.g. fetch/XHR)
    MetricData:        50,    // 50% of metrics
  };

  const rate = sampleRates[type] ?? 50; // default 50% for anything else
  return Math.random() * 100 < rate;    // return false to drop the event
});

export { appInsights, reactPlugin };